import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { SEAL_CHECKBOX_LABEL } from './sealModel';

interface SealApplyCheckboxProps {
  available: boolean;
  checked: boolean;
  onChange: (next: boolean) => void;
  id?: string;
}

/** Shows only when the Association keeps a seal. */
export function SealApplyCheckbox({ available, checked, onChange, id = 'apply-seal' }: SealApplyCheckboxProps) {
  if (!available) return null;
  return (
    <div className="flex items-start gap-3">
      <Checkbox id={id} checked={checked} onCheckedChange={(v) => onChange(v === true)} className="mt-1" />
      <Label htmlFor={id} className="text-sm font-normal leading-snug">
        {SEAL_CHECKBOX_LABEL}
      </Label>
    </div>
  );
}

export default SealApplyCheckbox;
